import { render, staticRenderFns } from "./business-role-modal.vue?vue&type=template&id=e452b456&scoped=true&"
import script from "./business-role-modal.vue?vue&type=script&lang=js&"
export * from "./business-role-modal.vue?vue&type=script&lang=js&"
import style0 from "./business-role-modal.vue?vue&type=style&index=0&id=e452b456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e452b456",
  null
  
)

export default component.exports